module.exports = __webpack_public_path__ + "media/images/PHI-Qauntum-5baab84224f0555f06aad6d999f8e7f7.jpeg";